import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import {
	getAndValidate,
	getAndValidateTraxAr,
} from "~/shared/services/api/fetch-client.ts";
import { getIsInternal } from "~/shared/utils/get-deployment-type.ts";

const ReportsFeatureAccessSchema = z.boolean();

const REPORTS_FEATURE_ACCESS_QUERY_KEY = "featureAccess";

export function useReportsFeatureAccess(
	customerId: number | undefined,
	enabled = true,
) {
	return useQuery({
		queryKey: [REPORTS_FEATURE_ACCESS_QUERY_KEY, customerId],
		queryFn: async (): Promise<boolean> => {
			const params = new URLSearchParams({
				CustomerId: String(customerId),
			});

			const url = `${apiRoutes.REPORTS_FEATURE_ACCESS}?${params.toString()}`;
			const fetcher = getIsInternal() ? getAndValidateTraxAr : getAndValidate;
			const result = await fetcher(url, ReportsFeatureAccessSchema);

			if (!result.success) {
				throw new Error(result.error);
			}

			return result.data;
		},
		enabled: !!customerId && enabled,
	});
}
